import { render, staticRenderFns } from "./ReservationCalendarLegend.vue?vue&type=template&id=b1ead0aa&scoped=true"
import script from "./ReservationCalendarLegend.vue?vue&type=script&lang=js"
export * from "./ReservationCalendarLegend.vue?vue&type=script&lang=js"
import style0 from "./ReservationCalendarLegend.vue?vue&type=style&index=0&id=b1ead0aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ead0aa",
  null
  
)

export default component.exports